import { useEffect, useState, useRef } from "react";

// Section reveal on scroll hook
export const useScrollReveal = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    observer.observe(currentRef);

    return () => {
      observer.disconnect();
    };
  }, []); // Empty deps - ref.current changes don't trigger re-render

  return [ref, isVisible];
};

export default useScrollReveal;
